import { useState, useEffect } from "react";
import PropTypes from "prop-types";

// @mui material components
import { Grid, IconButton, Icon } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDButton from "../../../../../components/MDButton";

import FormField from "../FormField";
import { FormControl, Select, InputLabel, MenuItem } from "@mui/material";

function UserInfo({ control, errors }) {
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [activePlatforms, setActivePlatforms] = useState([]);

  const socialMedia = useWatch({ control, name: "socialMedia" });

  useEffect(() => {
    if (socialMedia && typeof socialMedia === "object") {
      const keys = Object.keys(socialMedia).filter((key) => socialMedia[key]);
      const merged = Array.from(new Set([...activePlatforms, ...keys]));
      if (merged.length !== activePlatforms.length) {
        setActivePlatforms(merged);
      }
    }
  }, [socialMedia, activePlatforms, setActivePlatforms]);

  const platforms = [
    { value: "website", label: "Sitio web" },
    { value: "facebook", label: "Facebook" },
    { value: "instagram", label: "Instagram" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "twitter", label: "Twitter" },
  ];

  const handleAddPlatform = () => {
    if (selectedPlatform && !activePlatforms.includes(selectedPlatform)) {
      setActivePlatforms([...activePlatforms, selectedPlatform]);
      setSelectedPlatform("");
    }
  };

  const handleRemovePlatform = (platformToRemove) => {
    setActivePlatforms(activePlatforms.filter((p) => p !== platformToRemove));
  };

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Información de usuario
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Email"
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="username"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Nombre de usuario"
                error={!!errors.username}
                helperText={errors.username?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Contraseña"
                type="password"
                error={!!errors.password}
                helperText={errors.password?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <MDTypography variant="h5" mt={2} mb={1}>
            Redes sociales
          </MDTypography>
          <MDBox display="flex" alignItems="center" gap={2} mb={2}>
            <FormControl sx={{ minWidth: 400 }} variant="outlined">
              <InputLabel id="platform-select-label">Seleccionar Red Social</InputLabel>
              <Select
                labelId="platform-select-label"
                value={selectedPlatform}
                label="Seleccionar Red Social"
                onChange={(e) => setSelectedPlatform(e.target.value)}
                sx={{ height: 45 }}
              >
                {platforms.map((p) => (
                  <MenuItem key={p.value} value={p.value} disabled={activePlatforms.includes(p.value)}>
                    {p.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <MDButton variant="gradient" color="info" onClick={handleAddPlatform} disabled={!selectedPlatform}>
              Añadir
            </MDButton>
          </MDBox>
        </Grid>

        {activePlatforms.map((platform) => {
          const platformLabel = platforms.find((p) => p.value === platform)?.label || platform;
          return (
            <Grid item xs={12} sm={6} key={platform}>
              <MDBox display="flex" alignItems="center">
                <Controller
                  name={`socialMedia.${platform}`}
                  control={control}
                  render={({ field }) => (
                    <FormField
                      {...field}
                      value={field.value || ""}
                      label={platformLabel}
                      error={!!errors.socialMedia?.[platform]}
                      helperText={errors.socialMedia?.[platform]?.message}
                      fullWidth
                    />
                  )}
                />
                <IconButton color="error" onClick={() => handleRemovePlatform(platform)} sx={{ ml: 1 }}>
                  <Icon>delete</Icon>
                </IconButton>
              </MDBox>
            </Grid>
          );
        })}

      </Grid>
    </MDBox>
  );
}

UserInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
};

export default UserInfo;
